import {IDefaultService} from '../iDefault.service';
import {AbstractRepositoryV2} from '../../abstractRepositoryV2';
import {AbstractDataServiceAdapter} from '../../dataservice/adapter/abstractDataService.adapter';
import {BehaviorSubject, Observable} from 'rxjs';
import {EntityCollectionServiceBase} from '@ngrx/data';

export abstract class AbstractDeleteOneService<StoredEntity, Entity> extends IDefaultService<StoredEntity, Entity> {

    readonly loading$: Observable<boolean> = new BehaviorSubject(false);
    readonly error$: Observable<any> = new BehaviorSubject(undefined);
    readonly deleted$: Observable<boolean> = new BehaviorSubject(false);

    protected constructor(repository: AbstractRepositoryV2<StoredEntity>,
                          dataService: AbstractDataServiceAdapter<StoredEntity, Entity, any>) {
        super(repository, dataService);
    }

    delete(entity: Entity): Promise<number | string> {
        const storedEntity = this.dataService.buildStoredEntityEntity(entity);
        const id = this.repository.selectId(storedEntity);
        return this.coreDelete(id, storedEntity);
    }
    protected coreDelete(id: number | string, storedEntity: StoredEntity): Promise<number | string> {
        this.setLoading(true);
        return new Promise<number | string>((resolve, reject) => {
            this.dataService.dataService.delete(id)
                .toPromise()
                .then(() => {
                    this.repository.deleted(storedEntity);
                    this.getRepositoriesToSynchronize().forEach(repo => repo.clearCache());
                    this.postDelete(storedEntity);
                    (this.deleted$ as BehaviorSubject<boolean>).next(true);
                    resolve(id);
                })
                .catch((e) => {
                    // console.logByType['delete result error', e]);
                    this.setError(e);
                    reject(e);
                })
                .finally(() => this.setLoading(false));
        });
    }

    protected getRepositoriesToSynchronize(): EntityCollectionServiceBase<any>[] {
        return [];
    }

    protected postDelete(storedEntity: StoredEntity): void {

    }


}
